
import Vue from 'vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


import './refresh-init.js'
import store from './vuex/store'
import dsBridge from 'dsbridge'
Vue.use(ToastPlugin)
/* eslint-disable */

const FastClick = require('fastclick')
var str = navigator.userAgent.toLowerCase()
var ver = str.match(/cpu iphone os (.*?) like mac os/)
if (!ver) {


FastClick.attach(document.body)
} else {
console.log('你當前的Ios系統版本為：' + ver[1].replace(/_/g, '.'))
if (parseInt(ver[1]) >= 11) {

} else {

FastClick.attach(document.body)
}
}

var swidth = document.documentElement.clientWidth

export default {
name: 'App',
components: {
ViewBox,
Alert,
Loading
},
async created() {

const isNingXiangApp = window.location.href.indexOf('ningxiang-apps') > -1

let me = this













dsBridge.call('getBaseInfo', function(res) {
let RES = JSON.parse(res)
if (RES) {
me.hideTile = true
}
})

if (isNingXiangApp) {
me.hideTile = true
}




},
mounted() {
let me = this

store.watch(
function(state) {
return state.isLoading
},
function(e) {
me.isLoadingStatus = e
},
{
immediate: true
}
)


store.watch(
function(state) {
return state.globalAlertStatus
},
function(e) {
me.alertStatus = e
},
{
immediate: true
}
)


store.watch(
function(state) {
return state.globalAlertText
},
function(e) {
me.alertText = e
},
{
immediate: true
}
)


store.watch(
function(state) {
return state.leftOptions
},
function(e) {
me.leftOptions = e
dsBridge.call('setTabBarLeft', e.showBack ? '1' : '0')
},
{
immediate: true
}
)


store.watch(
function(state) {
return state.title
},
function(e) {
me.title = e
dsBridge.call('setTabBarTitle', e)
},
{
immediate: true
}
)
},
watch: {
alertStatus(data) {
store.commit('setGlobalAlertStatus', data)
},
$route(to, from) {
if (from.name == 'login' || from.path.indexOf('home') > -1) {
this.direction = 'slide-left'
} else if (to.path.indexOf('home') > -1) {
this.direction = 'slide-right'
} else {
const toDepth = to.path.split('/').length
const fromDepth = from.path.split('/').length
this.direction = toDepth < fromDepth ? 'slide-right' : 'slide-left'
}

if (this.appWrap && this.appWrap.style) {
this.appWrap.style.transform = `translate(0, 0)`
setTimeout(() => {
this.appWrap.style.transition = 'transform 0.2s ease-out'
setTimeout(() => (this.appWrap.style.transform = 'none'))
})
}
},
'$store.state.clickBack'(newValue, oldValue) {
this.clickBack = newValue
}
},
data() {
return {
isLoadingStatus: false,
alertStatus: '',
alertText: store.state.globalAlertText,
leftOptions: {},
title: '',
transitionName: '',
hideTile: false,
clickBack: function() {},


direction: 'slide-left',

touchLeft: swidth / 10,

touchStartPoint: {
pageX: 0,
pageY: 0
},

distanceX: 0,
distanceY: 0,

backBtn: null,
appWrap: null,
maxOffsetX: 100,
maxOffsetY: 30
}
},
methods: {







bodyTouchStart: function(event) {
this.backBtn = document.querySelector('.vux-header-left')
this.appWrap = document.getElementById('app')
if (this.backBtn) {

this.touchStartPoint = {
pageX: event.targetTouches[0].pageX,
pageY: event.targetTouches[0].pageY
}
this.distanceX = 0
this.distanceY = 0
}
},
bodyTouchMove: function(event) {
if (this.backBtn && this.touchStartPoint.pageX < this.touchLeft) {

if (event.targetTouches.length > 1) {
return
}

this.distanceX = event.targetTouches[0].pageX - this.touchStartPoint.pageX
this.distanceY = Math.abs(event.targetTouches[0].pageY - this.touchStartPoint.pageY)
if (this.distanceY < this.maxOffsetY) {
this.appWrap.style.transform = `translate(${this.distanceX}px, 0)`

if (this.distanceX > 0 && this.distanceX < this.maxOffsetX) {

this.backBtn.style.background = 'green'
} else if (this.distanceX >= this.maxOffsetX) {

this.backBtn.style.background = 'red'
} else {

this.backBtn.style.background = 'none'
}
} else {
this.backBtn.style.background = 'none'
this.appWrap.style.transform = `translate(0, 0)`
setTimeout(() => (this.appWrap.style.transform = 'none'))
}
}
},
bodyTouchEnd: function(event) {
if (this.backBtn && this.touchStartPoint.pageX < this.touchLeft) {

this.touchStartPoint.pageX = 0
this.backBtn.style.backgroundPosition = '-50px 0'

if (this.distanceX > this.maxOffsetX && this.distanceY < this.maxOffsetY) {
const isHome = this.$route.path === '/' || this.$route.path === '/home'
if (isHome) {
this.$vux.toast.text('首页无法再返回了', 'top')
this.appWrap.style.transform = `translate(0, 0)`
setTimeout(() => (this.appWrap.style.transform = 'none'))
} else {
this.appWrap.style.transform = `translate(${swidth}px, 0)`
setTimeout(() => {
this.$router.go(-1)
this.appWrap.style.transition = 'none'
}, 200)
}






} else {
this.appWrap.style.transform = `translate(0, 0)`
setTimeout(() => (this.appWrap.style.transform = 'none'))
}
}
this.backBtn.style.background = 'none'
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue